import Button from '@loggi/ui/components/button';
import colors from '@loggi/ui/components/utils/colors';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import Col from '@loggi/ui/components/col';
import Text, { TEXT_SIZE_LARGE } from '@loggi/ui/components/text';
import PropTypes from 'prop-types';
import RecipientInfo from './recipient-info.component';
import LocalInfo from './local-info.component';
import React from 'react';
import {
  messageText,
  messageTextsComplementaryInfoLayout,
  DENY_DELIVERY_BUTTON_TEXT,
  CONFIRM_DELIVERY_BUTTON_TEXT,
  CONFIRM_DELIVERY_ID,
  DELIVERY_LOCATION_MAP
} from './confirm-delivery.constants';
import styles from './confirm-delivery.styles.scss';
export default function ConfirmDelivery({
  onClickToDeny,
  onClickToConfirm,
  isDisabled,
  receivedBy,
  locationCode,
  recipientRelationship,
  enableComplementaryDeliveryInfoLayout
}) {
  return (
    <Col className={styles.confirmDelivery} data-testid={CONFIRM_DELIVERY_ID}>
      {enableComplementaryDeliveryInfoLayout ? (
        <Col>
          <Col className="question">
            <Text size={TEXT_SIZE_LARGE}>
              {
                messageTextsComplementaryInfoLayout.CONFIRM_DELIVERY_QUESTION_TEXT
              }
            </Text>
          </Col>
          <Col className="question-complement" gutter={{ top: 'half' }}>
            <Text>
              {
                messageTextsComplementaryInfoLayout.CONFIRM_DELIVERY_QUESTION_TEXT_COMPLEMENT
              }
            </Text>
          </Col>
          {(locationCode === DELIVERY_LOCATION_MAP.INVALID.option ||
            locationCode === DELIVERY_LOCATION_MAP.RECIPIENT.option ||
            locationCode === DELIVERY_LOCATION_MAP.OTHER_OPTION.option ||
            locationCode === null) && (
            <Col>
              <RecipientInfo receivedBy={receivedBy} />
            </Col>
          )}
          {locationCode === DELIVERY_LOCATION_MAP.OTHER_RECIPIENT.option && (
            <Col>
              <RecipientInfo receivedBy={receivedBy} />
              <Col className="delivery-info">
                <Text>{DELIVERY_LOCATION_MAP.OTHER_RECIPIENT.text}</Text>
              </Col>
              <Col className="delivery-data">
                <Text>{recipientRelationship}</Text>
              </Col>
            </Col>
          )}
          {locationCode === DELIVERY_LOCATION_MAP.CONCIERGE.option && (
            <Col>
              <RecipientInfo receivedBy={receivedBy} />
              <LocalInfo localText={DELIVERY_LOCATION_MAP.CONCIERGE.text} />
            </Col>
          )}
          {locationCode === DELIVERY_LOCATION_MAP.MAILBOX.option && (
            <Col>
              <LocalInfo localText={DELIVERY_LOCATION_MAP.MAILBOX.text} />
            </Col>
          )}
        </Col>
      ) : (
        <Col>
          <Text bold>{messageText.CONFIRM_DELIVERY_QUESTION_TEXT}</Text>
        </Col>
      )}
      <Col className="buttons-confirm-deny">
        <Col>
          <Button
            color={colors.type.BLUE}
            shape={ROUNDED_SHAPE}
            style="primary"
            value={CONFIRM_DELIVERY_BUTTON_TEXT}
            onClick={onClickToConfirm}
            disabled={isDisabled}
          />
        </Col>
        <Col>
          <Button
            shape={ROUNDED_SHAPE}
            style="outline"
            value={DENY_DELIVERY_BUTTON_TEXT}
            onClick={onClickToDeny}
            disabled={isDisabled}
          />
        </Col>
      </Col>
    </Col>
  );
}

ConfirmDelivery.displayName = 'ConfirmDelivery';

ConfirmDelivery.propTypes = {
  onClickToDeny: PropTypes.func.isRequired,
  onClickToConfirm: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  receivedBy: PropTypes.string.isRequired,
  locationCode: PropTypes.number.isRequired,
  enableComplementaryDeliveryInfoLayout: PropTypes.bool,
  recipientRelationship: PropTypes.number
};

ConfirmDelivery.defaultProps = {
  enableComplementaryDeliveryInfoLayout: false,
  recipientRelationship: null
};
